import React, {useState} from 'react';
import {FormattedMessage, useIntl} from "react-intl";
import {Formats} from "../../../../../constants/Formats";
import {RequestVisitorDto} from "../../../../../modules/vms/dto/RequestVisitorDto";
import dayjs from "dayjs";
import {HttpStatus} from "../../../../../modules/common/enums/HttpStatus";
import {RequestVisitorApi} from "../../../../../modules/vms/api/RequestVisitorApi";
import {VisitRequestDto} from "../../../../../modules/vms/dto/VisitRequestDto";
import {
    Link, Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import {VisitorAccessLogDto} from "../../../../../modules/vms/dto/VisitorAccessLogDto";
import {VisitorStatus} from "../../../../../modules/vms/enums/VisitorStatus";
import StringUtils from "../../../../../utils/StringUtils";
import {useConfirm} from "material-ui-confirm";
import InputCardDialog from "./InputCardDialog";

export type SearchResultProps = {
    searchResult: Array<RequestVisitorDto>;
    onSortSearch: (sortField: string, sortType: string) => void;
    onSearch: () => void;
    onClickDetail:(id:string)=>void;
};

const SearchResult: React.FC<SearchResultProps> = (props) => {
    const intl = useIntl();
    const confirm = useConfirm();
    const [openInputCardDialog, setOpenInputCardDialog] = useState(false);

    const [currentRow, setCurrentRow] = useState<RequestVisitorDto>(new RequestVisitorDto());

    const _handleCheckOutRowSelect = (row: RequestVisitorDto) => {
        setCurrentRow(row);
        setOpenInputCardDialog(true);
    }

    const _handleCheckOut = async (id: string, accessCardNumber: string) => {
        const responseResult = await RequestVisitorApi.checkout(id, accessCardNumber);
        if (responseResult.status === HttpStatus.SUCCESS) {
            props.onSearch();
            setOpenInputCardDialog(false);
        }
    }

    return (
        <div>
            <InputCardDialog onCancel={() => setOpenInputCardDialog(false)}
                             onOk={(cardNumber) => _handleCheckOut(currentRow.id, cardNumber)}
                             open={openInputCardDialog}
                             accessCardNumber={currentRow.accessCardNumber}/>
            <TableContainer>
                <Table size="small"
                       sx={{minWidth:1500, overflow: 'auto'}}>
                    <TableHead>
                        <TableRow>
                            {/*<TableCell>{intl.formatMessage({id: 'VMS_REQUEST_VISITOR_ARRIVE_DATE'})}</TableCell>*/}
                            <TableCell>{intl.formatMessage({id: "VMS_REQUEST_VISITOR_NAME"})}</TableCell>
                            <TableCell>{intl.formatMessage({id: "VMS_REQUEST_VISITOR_COMPANY"})}</TableCell>
                            <TableCell>{intl.formatMessage({id: "VMS_VISIT_REQUEST_HOST_NAME"})}</TableCell>
                            <TableCell>{intl.formatMessage({id: "VMS_REQUEST_VISITOR_VISIT_CODE"})}</TableCell>
                            <TableCell>{intl.formatMessage({id: "VMS_REQUEST_VISITOR_ACCESS_CARD_NUMBER"})}</TableCell>
                            <TableCell>{intl.formatMessage({id: "VMS_REQUEST_VISITOR_PLATE_NUMBER"})}</TableCell>
                            <TableCell>{intl.formatMessage({id: "VMS_REQUEST_VISITOR_STATUS"})}</TableCell>
                            <TableCell>{intl.formatMessage({id: "VMS_REQUEST_VISITOR_ACCESS_IN_TIME"})}</TableCell>
                            <TableCell>{intl.formatMessage({id: "VMS_REQUEST_VISITOR_ACCESS_IN_READER"})}</TableCell>
                            <TableCell>{intl.formatMessage({id: "VMS_REQUEST_VISITOR_ACCESS_OUT_TIME"})}</TableCell>
                            <TableCell>{intl.formatMessage({id: "VMS_REQUEST_VISITOR_ACCESS_OUT_READER"})}</TableCell>
                            <TableCell>{intl.formatMessage({id: 'COMMON_ACTION'})}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.searchResult.map((row, index) => {
                            const checkOutLog = row.checkOutLog && Object.assign(new VisitorAccessLogDto(), row.checkOutLog);
                            const checkInLog = row.checkInLog && Object.assign(new VisitorAccessLogDto(), row.checkInLog);
                            const visitRequest = row.visitRequest ? row.visitRequest : new VisitRequestDto();
                            let rowStyle = {};
                            if (checkInLog && checkOutLog == null) {
                                if (dayjs(row.visitRequest?.arriveEndDate, Formats.DATE_SIMPLE).isBefore(dayjs(), 'day')) {
                                    rowStyle = {backgroundColor: "#ffb08e"};
                                }
                            }
                            return (
                                <TableRow key={row.id} style={rowStyle}>
                                    {/*<TableCell>{StringUtils.formatDate(visitRequest.arriveStartDate) + " " + StringUtils.formatTime(visitRequest.arriveStartTime)}&nbsp;-&nbsp;*/}
                                    {/*    {StringUtils.formatTime(visitRequest.arriveEndTime)}</TableCell>*/}
                                    <TableCell>{row.fullName}</TableCell>
                                    <TableCell>{row.company}</TableCell>
                                    <TableCell>{visitRequest.hostFullName}</TableCell>
                                    <TableCell>{row.visitCode}</TableCell>
                                    <TableCell>{row.accessCardNumber}</TableCell>
                                    <TableCell>{row.plateNumber}</TableCell>
                                    <TableCell><FormattedMessage
                                        id={VisitorStatus.Map.get(row.status)}/></TableCell>
                                    <TableCell>{StringUtils.formatDate(row.accessInLog?.accessDate) + " " + StringUtils.formatTime(row.accessInLog?.accessTime)}</TableCell>
                                    <TableCell>{row.accessInLog?.accessReader}</TableCell>
                                    <TableCell>{StringUtils.formatDate(row.accessOutLog?.accessDate) + " " + StringUtils.formatTime(row.accessOutLog?.accessTime)}</TableCell>
                                    <TableCell>{row.accessOutLog?.accessReader}</TableCell>
                                    <TableCell>
                                        <Stack direction={'row'} spacing={1}>
                                            <Link href={'javascript:void(0)'} onClick={() => props.onClickDetail(row.id)}>
                                                <FormattedMessage id={'COMMON_DETAIL'}/>
                                            </Link>
                                            {
                                                row.accessCardNumber && !row.accessOutLog &&
                                                <Link href={'javascript:void(0)'}
                                                      onClick={() => _handleCheckOutRowSelect(row)}>
                                                    <FormattedMessage id={'VMS_REQUEST_VISITOR_ACCESS_OUT'}/>
                                                </Link>
                                            }
                                        </Stack>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
};

export default SearchResult;